import { ApiUtility } from "./ApiUtility";

export interface IUTMPayload {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  landing_page?: string;
  landing_url?: string;
  referrer?: string;
  first_visit?: string;
  last_visit?: string;
}

class UTMServiceClass {
  private route = "/api/ProductInfo/track";

  track = (payload: IUTMPayload) => {
    return ApiUtility.post(this.route, payload);
  };
}

const UTMService = new UTMServiceClass();
export default UTMService;
